export default "__VITE_ASSET__446ef5db__"